import { Directive, ElementRef, OnInit, inject } from '@angular/core';

@Directive({
  selector: '[appLabelStyle]',
  standalone: true,
})
export class LabelStyleDirective implements OnInit {
  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  public ngOnInit(): void {
    this.configureStyles();
  }

  private configureStyles(): void {
    this.elementRef.nativeElement.classList.add(
      'mb-1',
      'font-semibold',
      'text-gray-700',
    );
  }
}
